import React from 'react';
import styled from '@emotion/styled';

import Icon from '~/core/scripts/components/Icon';
import * as S from './MapDrawer.styles';

const LoaderWrapper = styled.div`
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Loader = () => {
  return (
    <S.MapDrawerInner>
      <LoaderWrapper>
        <Icon className="spin" type="loading" />
      </LoaderWrapper>
      <div style={{ height: 65 }} />
      <div className="leaflet-container" />
    </S.MapDrawerInner>
  );
};

export default Loader;
